import React, { useContext } from 'react';
import { ComboGroupContext, IComboGroupContext } from '../../../comboGroupState/comboGroupContext';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString, comboGroups } = useContext<IComboGroupContext>(ComboGroupContext);

	return (
		<SearchField
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={comboGroups.comboGroupsCount ? 800 : undefined}
		/>
	);
};

export default Search;
